import { Link } from "react-router-dom";
import { Skull } from "lucide-react";

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/5 bg-background/60 px-6 py-10">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 md:flex-row">
      <Link to="/" className="flex items-center gap-2">
        <Skull className="h-5 w-5 text-primary" />
        <span className="font-display text-xl tracking-wider">DBD <span className="text-primary">CREATOR HUB</span></span>
      </Link>
      <p className="text-xs text-foreground/40">
        Built for Dead by Daylight content creators. Not affiliated with Behaviour Interactive.
      </p>
    </div>
  </footer>
);

export default Footer;
